import type { PickedFile } from "web_myplann/Portfolio/Forms/DocumentUploadForm/documentUploadFormSchema";
import { fileNameWithoutExtension } from "web_myplann/Shared/Utils/fileNameWithoutExtension";

type Args = {
	currentName: string;
	previousFile: PickedFile | null;
	nextFile: PickedFile | null;
};

export const getAutofilledDocumentName = ({
	currentName,
	previousFile,
	nextFile,
}: Args): string => {
	if (nextFile === null) {
		return currentName;
	}

	const previousName = previousFile
		? fileNameWithoutExtension(previousFile.filename)
		: "";
	const isNameUntouched = currentName === "" || currentName === previousName;

	return isNameUntouched
		? fileNameWithoutExtension(nextFile.filename)
		: currentName;
};
